import { Component } from 'san';
import * as _ from 'lodash';

import { IHandlerPerson, IUser, IWorkflowStep } from 'src/models';
import { EWorkflowStepStatus } from 'src/enums';

import workflowService from 'src/services/workflow.service';
import checkOrgUsersService from 'src/services/checkOrgUsers.service';

export default class WorkflowStep extends Component {
    static computed = {
        // 显示按钮：添加审批人、删除
        _showEditButtons() {
            const current = this.data.get('current');
            const rank = this.data.get('data.rank');
            const editEnable = this.data.get('editEnable');
            // 可编辑 && 节点未完成
            return editEnable && current < rank;
        },
        // 显示按钮：在左侧添加
        _showAddStepBefore() {
            const current = this.data.get('current');
            const rank = this.data.get('data.rank');
            const editEnable = this.data.get('editEnable');
            // 可编辑 && 节点未完成 && hover
            return editEnable && current < rank;
        },
        // 显示按钮：在右侧添加
        _showAddStepAfter() {
            const current = this.data.get('current');
            const rank = this.data.get('data.rank');
            const editEnable = this.data.get('editEnable');
            // 可编辑 && (节点未完成||正在进行中) && hover
            return editEnable && current <= rank;
        },
        // 人员 hover 高亮
        _showHoverPerson() {
            const current = this.data.get('current');
            const rank = this.data.get('data.rank');
            const editEnable = this.data.get('editEnable');
            // 可编辑 && 节点未完成 && hover
            return editEnable && current < rank;
        },
        // 显示增删审批人按钮
        _showEditPersons() {
            const current = this.data.get('current');
            const rank = this.data.get('data.rank');
            const editEnable = this.data.get('editEnable');
            const disableAddPerson = this.data.get('data.disable_add_person');
            // 可编辑 && 节点未完成 && 允许增删审批人
            return editEnable && current < rank && !disableAddPerson;
        }
    };

    checkUsersComponent: any; // 选择用户组件

    constructor(options: any) {
        super(options);
    }

    initData(): {
        editEnable: boolean; // {{}}
        isNew: boolean;
        data: IWorkflowStep; // {{}}
        current: number; // 当前节点的rank
        workflowStepStatusEnum: any;
    } {
        return {
            editEnable: false,
            isNew: false,
            data: null,
            current: 0,
            workflowStepStatusEnum: EWorkflowStepStatus,
        };
    }

    inited() {}

    toAddPersons() {
        const data = this.data.get('data');
        checkOrgUsersService.show({
            isMultiple: 1 !== data.person_limit_max,
            callback: (users) => {
                this.addPersons(users);
            },
        });
    }
    addPersons(persons: IUser[]) {
        persons = workflowService.users2WorkflowStepHandlePersonsSync(persons);
        const data = this.data.get('data');
        const oldPersons: IHandlerPerson[] = data.persons;
        const personLimitMax = data.person_limit_max;
        let newPersons: IHandlerPerson[] = [];
        // 限制选一人
        if (1 === personLimitMax) {
            newPersons = persons;
            // 限制 n 个人
        } else {
            // 拼接去重
            newPersons = _.uniqBy([...oldPersons, ...persons], 'user_id');
            // 限制人数
            // if (WORKFLOW_STEP_PERSON_LIMIT_INFINITE !== personLimitMax && newPersons.length > personLimitMax) {
            //     toasterService.show({ type: 'warning', title: `『${data.name}』节点的审批人数不能超过 ${personLimitMax} 人` });
            //     newPersons = _.take(newPersons, personLimitMax);
            // }
        }
        data.persons = newPersons;
        this.fire('data-change', data);
    }

    deletePerson(person: IUser) {
        const data = this.data.get('data');
        data.persons = _.reject(data.persons, { user_id: person.user_id });
        this.fire('data-change', data);
    }
    //#endregion

    check() {
        if (!this.data.get('editEnable')) {
            return;
        }
        if (this.data.get('data')._is_checked) {
          $('input#title').blur();
        }
        this.fire('check-change', this.data.get('data'));
    }

    changeTitle() {
        const data = this.data.get('data');
        data.name = data.name && data.name.trim();
        this.fire('data-change', data);
    }

    addStepBefore() {
        this.fire('add-step', {
            location: 'before',
            step: this.data.get('data'),
        });
    }

    addStepAfter() {
        this.fire('add-step', {
            location: 'after',
            step: this.data.get('data'),
        });
    }

    deleteStep() {
        this.fire('delete-step', this.data.get('data'));
    }
}
